import { QueryCache, QueryClient } from '@tanstack/react-query';
import { toaster } from '../../ui';

function createQueryClient() {
    const queryCache = new QueryCache({
        onError: (_error, query) => {
            const errorMessage = query.meta?.errorMessage;

            if (typeof errorMessage === 'string') {
                toaster.makeToast({
                    severity: 'error',
                    message: errorMessage,
                    autoHideDuration: 5000,
                });
            }
        },
    });

    const queryClient = new QueryClient({
        defaultOptions: {
            queries: {
                refetchOnWindowFocus: false,
            },
        },
        queryCache,
    });

    return queryClient;
}

export const queryClient = createQueryClient();
